export default __webpack_public_path__ + "static/home-fb98872635d0ea358add85f9a0722061.webp";